<template>
  <div
    v-if="show"
    class="center"
    :style="`height:${bodyHeight - 80}px;width: 100%;`"
  >
    <div class="container mt-4">
      <!-- <div class="google-map" id="map3"></div> -->
      <div class="mapbox-maps" style="height: 100%;">
        <div id="map2" style="height: 100%;"></div>
      </div>
      <div
        class="btns"
        :style="`width:${bodyWidth - 260 * 1 - 35}px;z-index: 99999;`"
      >
        <div class="cancel" @click="handCancel" style="cursor:pointer;">
          {{$t('selection.cancel')}}
        </div>
        <div class="zdy-input">
          <div class="input">
            <input
              style="text-align: center;"
              type="number"
              v-model="radus"
              @input="handInput"
            />
          </div>
          <div class="danwei">{{ $t('M') }}</div>
        </div>
        <div class="confirm" @click="handConfirm" style="cursor:pointer;">
          {{$t('selection.ok')}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mapboxgl from "mapbox-gl";
import "mapbox-gl/dist/mapbox-gl.css";
import { getMapKeys } from "@/api/user.js";
export default {
  data() {
    return {
      timer: null,
      radus: 2000,
      selectInfo: {},
      markers: [],
      infowindows: [],
      bodyWidth: document.body.clientWidth || window.innerWidth,
      bodyHeight: document.body.clientHeight || window.innerHeight,
      map: null,
      lat: 40.772072448457735,
      lng: -73.99482299312687,
      show: false,
    };
  },
  methods: {
    handInput(e) {
      if (this.timer) {
        clearTimeout(this.timer);
      }
      console.log(e);
      this.timer = setTimeout(() => {
        clearTimeout(this.timer);
        this.handBlur(e);
      }, 500);
    },
    handBlur(e) {
      if (!e.target._value) {
        return;
      }
      if (Number(e.target._value) <= 0) {
        return;
      }
      this.radus = Number(e.target._value);
      if (this.selectInfo && this.selectInfo.lat) {
        for (let i = 0; i < this.markers.length; i++) {
          this.markers[i].setMap(null);
        }
        this.markers = [];
        this.initCircular(this.selectInfo);
        this.setMarker(this.selectInfo.lat, this.selectInfo.lng, 0);
      }
    },
    handCancel() {
      for (let i = 0; i < this.markers.length; i++) {
        this.markers[i].setMap(null);
      }
      this.markers = [];
      this.infowindows.forEach((el) => {
        el.infowindow.close();
      });
      this.show = false;
    },
    handConfirm() {
      if (!this.selectInfo && !this.selectInfo.lat) {
        return;
      }
      const params = {
        ...this.selectInfo,
        radus: this.radus,
      };
      this.$emit("change", params);
      this.handCancel();
    },
    showEdit(row) {
      this.show = true;
      if (row && row.radus) {
        this.radus = row.radus;
      } else {
        this.radus = 2000;
      }
      this.$nextTick(() => {
        // this.initMap(row);
        this.initMap(row);
      });
    },
    async initMap(row) {
      const ddd = await getMapKeys();
      let myIcon = L.icon({
        iconUrl: require("./../assets/img/lastMap.png"),
        iconSize: [27, 40],
        iconAnchor: [15, 32],
      });
      if (row && (row.lat || row.latitude)) {
        this.lat = row.lat || row.latitude;
      }
      if (row && (row.lng || row.longitude)) {
        this.lng = row.lng || row.longitude;
      }

      setTimeout(() => {
        this.map = L.map(`map2`, {
          center: [Number(this.lat), Number(this.lng)], // 地图中心
          zoom: 15, //缩放比列
          zoomControl: false, //禁用 + - 按钮
          doubleClickZoom: false, // 禁用双击放大
          attributionControl: false, // 移除右下角leaflet标识
        });
        L.tileLayer(
          `https://api.mapbox.com/styles/v1/mapbox/streets-v9/tiles/256/{z}/{x}/{y}@2x?access_token=${ddd.data.key}`,
          {
            minZoom: 5,
            maxZoom: 18,
          }
        ).addTo(this.map);
        this.selectInfo = row;
        this.map.on("click", (e) => {
          let latlng = e.latlng;
          this.selectInfo = latlng;
          if (this.marker) {
            this.marker.setLatLng([latlng.lat, latlng.lng]);
          } else {
            this.marker = L.marker([latlng.lat, latlng.lng], {
              icon: myIcon,
            }).addTo(this.map);
          }
          if (this.circle) {
            this.circle.setLatLng([latlng.lat, latlng.lng]);
            this.circle.setRadius(Math.sqrt(this.radus / 100) * 100);
          } else {
            this.circle = L.circle([latlng.lat, latlng.lng], {
              radius: Math.sqrt(this.radus / 100) * 100,
              color: "#FF0000",
            }).addTo(this.map);
          }
        });

        if (row) {
          this.marker = L.marker([Number(this.lat), Number(this.lng)], {
            icon: myIcon,
          }).addTo(this.map);
          this.circle = L.circle([Number(this.lat), Number(this.lng)], {
            radius: Math.sqrt(this.radus / 100) * 100,
            color: "#FF0000",
          }).addTo(this.map);
        }
      }, 500);
    },
  },
};
</script>

<style scoped>
.center {
  width: 97%;
  margin: 20px auto;
  position: absolute;
  top: 0;
}
.container {
  display: flex;
  height: 100%;
  flex-direction: column;
}

.google-map {
  /* width: 750rpx; */
  flex: 1;
}

.btns {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
  height: 46px;
  position: fixed;
  background-color: #fff;
  bottom: 0;
}
.btns .cancel {
  font-size: 16px;
}
.btns .zdy-input {
  /* width: 130px; */
  display: flex;
  align-items: center;
  font-size: 16px;
  margin: 0 24px;
}
.danwei {
  margin-left: 20px;
}
.btns .confirm {
  color: #2979ff;
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/selection.vue